import { Routes } from '@angular/router';

const title = 'Configuración';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'videoteca',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Videoteca' }] },
        loadComponent: () => import('./pages/videoteca-lista/videoteca-lista.component'),
      },
    
    ],
  },

];
